import { Box } from "@mui/material";
import { pageContainer } from "./styles";

const PageContainer = ({ children }) => {
  return <Box sx={(theme) => pageContainer(theme)}>{children}</Box>;
};

export default PageContainer;
